import IconButton from '@mui/material/IconButton'
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  Switch,
  Typography
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import MainCard, { ConfirmationDialog } from '../../../utils/ui_utils'
import { borderColor, padding } from 'polished'
import { Height } from '@mui/icons-material'
import { values } from 'lodash'
import { usePaymentMethodUpdate } from '../../../modules/paymentMethod/paymentMethodHooks'
import { MessageCircle } from 'react-feather'

const PaymentMethodComponent = ({
  initialValues,
  okText,
  onSubmit,
  onDeleteSuccess,
  onError
}) => {
  const [paymentMethods, setPaymentMethods] = useState()
  const [deleteConfirmationVisibility, setDeleteConfirmationVisibility] =
    useState(false)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState()
  const { updatePaymentMethod } = usePaymentMethodUpdate()

  useEffect(() => {
    setPaymentMethods(initialValues.data)
  }, [])

  const handleSwitchChange = (_id) => {
    setPaymentMethods((paymentMethods) =>
      paymentMethods.map((method) =>
        method._id === _id
          ? { ...method, payment_method_flag: !method.payment_method_flag }
          : method
      )
    )
  }

  const handleDelete = (method) => {
    // setPaymentMethods(prevMethods => prevMethods.filter(method => method._id !== _id));
    // onDelete(_id);
    setSelectedPaymentMethod(method)
    setDeleteConfirmationVisibility(true)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    onSubmit(paymentMethods)
  }

  return (
    <>
      <ConfirmationDialog
        visibility={deleteConfirmationVisibility}
        title={'Delete Payment Method'}
        message={`Do you want to delete Payment Method ${selectedPaymentMethod?.payment_method} `}
        okText="Delete"
        cancelText={'Cancel'}
        onCancel={() => {
          setDeleteConfirmationVisibility(false)
        }}
        onOk={async () => {
          let payload = {
            _id: selectedPaymentMethod?._id,
            payment_method_flag: selectedPaymentMethod?.payment_method_flag,
            delete_status: true,
            outlet_id: selectedPaymentMethod?.outlet_id,
            payment_method: selectedPaymentMethod?.payment_method
          }
          await updatePaymentMethod(payload, (success, error, res) => {
            if (success) {
              onDeleteSuccess(res)
            } else if (error) {
              onError(res, 'error')
              setDeleteConfirmationVisibility(false)
            } else {
              onError(res, 'error')
              setDeleteConfirmationVisibility(false)
            }
          })
        }}
      />
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {paymentMethods?.map((method) => (
            <Grid item xs={12} md={6} lg={4} key={method._id.toString()}>
              <MainCard>
                <Grid
                  container
                  sx={{
                    p: 3,
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                  }}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                >
                  <Grid item pt={2}>
                    <Typography variant="h6">
                      {method.payment_method}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Switch
                      disabled={method.payment_method === 'Cash' ? true : false}
                      checked={method.payment_method_flag}
                      onChange={() => handleSwitchChange(method._id)}
                      color="primary"
                    />
                    <IconButton
                      disabled={method.payment_method === 'Cash' ? true : false}
                      onClick={() => {
                        handleDelete(method)
                      }}
                      color="error"
                    >
                      <DeleteOutlineIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </MainCard>
            </Grid>
          ))}
        </Grid>
        <Grid container justifyContent={'flex-end'}>
          <Grid item>
            <Button type="submit" variant="outlined" color="primary">
              {okText}
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default PaymentMethodComponent
